import './about.css'
import React from 'react'
import img from '../images/about.png'
import Button from '../Boutton/Button';


function About() {
  return (
    <div className='about' id='aboutid'>
        <div className='container'>
            <div className="row">
                <div className='col-lg-6 col-md-12 mb-5 mb-lg-0'>
                    <img src={img} alt="الشعار" />
                </div>
                <div className='col-lg-6 col-md-12 mb-5 mb-lg-0 mt-lg-1 mt-md-5'>
                <div class="section-title about2">
                        <h5 class="sub-titleall subabout">نبذه عن المركز </h5>
                        <h4 class="titleabout ">تم تأسيس مركز دكتور كار لصيانة السيارات منذ سنوات عديدة، وهو يقدم خدمات ميكانيكا السيارات لكافة أنواع السيارات سواء كانت تعمل بالبنزين أو الديزل. يتميز المركز بخبرته الكبيرة في تركيب مكائن السيارات بأنواعها المختلفة وبضمان جودة الخدمة.</h4>
                        <p>خدمات تركيب المكائن التي نقدمها:</p>
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-6">
                            <ul>
                            <li>مكائن كامري</li>
                            <li>مكائن سوناتا</li>
                            <li>مكائن اكسنت</li>
                            <li>مكائن كورولا</li>
                            <li>مكائن ربع</li>
                            <li>مكائن صني</li>
                        </ul>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6">
                            <ul>
                            <li>مكائن يارس</li>
                            <li>مكينة ددسن بخاخ</li>
                            <li>مكائن ددسن</li>
                            <li>مكائن هايلوكس</li>
                            <li>مكائن لكزس</li>
                        </ul>
                            </div>
                        </div>
                        <p> ضمان الجودة:</p>
                        <ul>
                            <li>نحن نقدم جميع المكائن مستوردة وبضمان لتأكيد الجودة والأداء الممتاز.</li>
                        </ul>
                        </div>
                </div>
                <Button />

            </div>
        </div>
    </div>
  )
}

export default About